<template>
  <TransitionRoot
    :show="modal.isVisible(name)"
    @beforeEnter="emit('onOpen')"
    @beforeLeave="emit('onClose')"
  >
    <Dialog class="z-modal fixed inset-0" @close="closeModal">
      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <DialogOverlay class="fixed inset-0 bg-black bg-opacity-30" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-hidden">
        <div
          class="vh-screen pointer-events-none flex flex-col items-center justify-center overflow-hidden p-5 md:p-6"
        >
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <DialogPanel
              class="pointer-events-auto relative flex min-h-[500px] max-w-[780px] overflow-hidden rounded-3xl"
            >
              <div class="left flex basis-1/2 items-center justify-center">
                <img
                  width="264"
                  height="264"
                  src="../assets/percent.webp"
                  alt="percent"
                />
              </div>

              <div
                class="relative basis-1/2 rounded-r-3xl bg-white p-6 text-center text-gray-800"
              >
                <div class="space-y-8 whitespace-pre-line">
                  <div>
                    <h3 class="cashback-text text-2xl font-bold">
                      {{ t('cashbackInfo.base.title') }}
                    </h3>
                    <div
                      class="mb-3 mt-1 flex items-center justify-center gap-3 text-2xl font-bold"
                    >
                      <span>1%</span>
                      <img src="../assets/arrow.svg" alt="" />
                      <span>{{ MAX_CASHBACK_PERCENT }}%</span>
                    </div>
                    <p>
                      {{
                        t('cashbackInfo.base.description', {
                          maxPercent: MAX_CASHBACK_PERCENT,
                        })
                      }}
                    </p>
                  </div>
                  <div class="space-y-3 text-sm font-semibold">
                    <img
                      class="mx-auto"
                      src="../assets/freedom-tours-qr.webp"
                      width="128"
                      height="128"
                      alt="Freedom SuperApp QR"
                    />
                    <p>{{ t('cashbackInfo.scanQr') }}</p>
                    <p class="text-[#84889F]">
                      {{ t('cashbackInfo.leaveRequest') }}
                    </p>
                    <AuiButton
                      class="w-full"
                      type="button"
                      @click="$emit('onOpenRequestFormModal')"
                    >
                      {{ t('cashbackInfo.leaveRequestAction') }}
                    </AuiButton>
                  </div>
                </div>
                <button
                  class="absolute right-4 top-4"
                  type="button"
                  @click="closeModal"
                >
                  <img src="@icons/close/gray-800/24x24.svg" alt="" />
                </button>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup lang="ts">
  import {
    Dialog,
    DialogOverlay,
    DialogPanel,
    TransitionChild,
    TransitionRoot,
  } from '@headlessui/vue';
  import { AuiButton } from '@aviata/auiata';

  import { MAX_CASHBACK_PERCENT } from '@entities/freedom-cashback';

  import { injectModal } from '@/shared/modal';
  import { useCashbackInfoLocales } from '../locales';

  const props = defineProps<{
    name: string;
  }>();

  const emit = defineEmits<{
    onOpenRequestFormModal: [];
    onOpen: [];
    onClose: [];
  }>();

  const modal = injectModal();
  const { t } = useCashbackInfoLocales();

  const closeModal = () => {
    modal.hide(props.name);
  };
</script>

<style scoped>
  .left {
    background-image: linear-gradient(92.69deg, #b9c1f2 1.07%, #9594e0 100%);
  }

  .cashback-text {
    color: transparent;
    background: linear-gradient(269deg, #00c57f 2.02%, #036bb9 56.56%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
</style>
